<template>
  <!-- 确认订单头部 -->
  <div class="order-header">
    <van-nav-bar title="地址管理" left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" color="#666666" />
      </template>
    </van-nav-bar>
    <div v-if="list.length" class="address_box">
      <div v-for="item in list" :key="item.id" class="address_item" @click="goBackPay(item)">
        <div class="item_left">
          <div class="item_title">
            <span style="display:inline-block;margin-right:20px">{{ item.receiver }}</span>
            <span class="phone">{{ item.mobile }}</span>
            <div class="default_botton" :class="{'default_botton_active':item.is_default}" @click="setDefault(item)">{{ item.is_default?'默认地址':'设为默认' }}</div>
          </div>
          <div class="address_text">{{ completeAddress(item) }}</div>
        </div>
        <div class="item_right" @click.stop="goNewAddress(item)">
          <van-icon name="edit" size="20" color="#888888" />
        </div>
      </div>
    </div>
    <div v-else class="nodata" v-show="showEmpty">
      <div>
        <img src="@/assets/new_kong.png" alt="">
        <div class="nodata_text">你还没有添加地址哦~</div>
      </div>

    </div>
    <div class="bottom_btn">
      <van-button type="primary" block color="#EE2E2E" round @click="goNewAddress({})">添加新地址</van-button>
    </div>

  </div>
</template>
<script>
import { addressList, updateAddress } from '@/api/ePayPro.js'

import { EventBus } from "@/utils/event-bus.js";

export default {
  data() {
    return {

      list: [],
      showEmpty:false
    }
  },
  computed: {
    completeAddress(e) {
      return function(e) {
        return '' + e.province + e.city + e.county + e.detail_address
      }
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
  },
  created() {
    this.getData()
  },

  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1)
    },

    // 获取地址列表
    getData() {
      const dataInfo = {

      }
      addressList(dataInfo).then((res) => {
        console.log(res)
        this.showEmpty = true
        this.list = res.result.list
      })
    },
    // 设置默认地址
    setDefault(e) {
      if (!e.is_default) {
        updateAddress({ id: e.id }).then(res => {
          this.$Toast.success('设置成功')
          this.getData()
        })
      }
    },
    goBackPay(e) {
      console.log(e)
      // sessionStorage.setItem('chooseAddress', JSON.stringify(e))
        EventBus.$emit("chooseAddress", JSON.stringify(e))
      // this.$router.push({
      //   path:'/',
      // })
      this.$router.go(-1)
    },
    // 跳转添加新地址
    goNewAddress(e) {
      this.$router.push({ path: './addressInfo', query: { address: e }})
      // this.$router.push({ path: './addressInfo', query: { address: JSON.stringify(e) }})
    }

  }
}
</script>
<style scoped lang='scss'>
.default_botton_active{
     color:#fff  !important;
    background-color: #EE2E2E;
}
.bottom_btn{
    width: 70%;
    position: fixed;
    bottom: 40px;
    left: 15%;

}
.default_botton{
    display: inline-block;
    padding: 8px 20px;
    color:#EE2E2E  ;
    border: 1px solid #EE2E2E;
    font-size: 10PX;
    margin-left: 10px;
    border-radius: 999px;
}
.address_box{
  padding-bottom: 200px;
  .item_bottom{
    margin-top:20px;
    img{
      display: block;
      width: 100%;
      max-height: 2.2PX;
// height: 2px;
    }

  }
  .address_text{
      font-family: PingFangSC-Regular;
      font-size: 13PX;
      color: #999999;
      letter-spacing: 0;
    }
    .phone{
        font-size: 13PX;
    }
  .address_item{
  padding: 20px;
  border-top: 1px solid #eee;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  }
  .item_left{
    flex: 1;
  }
  .item_title{
    font-family: PingFangSC-Medium;
    font-size: 15PX;
    color: #222222;
    letter-spacing: 0;
    margin-bottom: 10px;
  }
  .item_right{
    width: 50px;
  }}
  .nodata{
    display: flex;
    justify-content: center;
    margin-top: 400px;
    img{
      display: block;
      width: 280px;
      margin: 0 auto;

    }
    .nodata_text{
      margin-top: 20px;
      font-family: PingFangSC-Regular;
      font-size: 14PX;
      color: #999999;
      letter-spacing: 0;
      text-align: center;
    }
  }
</style>
